const retirePlusModelStrategyText = {
  buttonText: 'A Note About Risks'
};
export default retirePlusModelStrategyText;
